/* export const validForm = form => {
  // Fields Form
  let inputs = [...form.querySelectorAll('input, select, textarea')];
  let inputsValids = inputs.reduce((myObj, i) => {
    // Input invalid
    if (!i.validity.valid) {
      i.classList.add('is-invalid');
      return myObj;
    }
    // Input valid
    i.classList.remove('is-invalid');
    myObj[i.name] = i.value;
    return myObj;
  }, {});
  return {
    body: inputsValids,
    valid: Object.getOwnPropertyNames(inputsValids).length === inputs.length,
  };
}; */

export const validForm = form => {
  // Fields Form
  let inputs = [...form.querySelectorAll('input, select, textarea')];

  let inputsValids = inputs.reduce((arr, i) => {
    // Input invalid
    if (!i.validity.valid) {
      i.classList.add('is-invalid');
      return arr;
    }
    // Input valid
    i.classList.remove('is-invalid');
    return [...arr, `${i.name}=${i.value}`];
  }, []);
  return {
    body: inputsValids.join('&'),
    valid: inputsValids.length === inputs.length,
  };
};


// WEBPACK FOOTER //
// ./src/formValid.js